module.exports = __webpack_public_path__ + "img/2.ca84e7f5.png";